<template>
  <div class="contact">
    <ul class="contact-list">
      <li class="contact-item">
        <svg-icon icon-class="icon_contact_tel" class-name="contact_tel_svg"></svg-icon>
        <p class="contact-text">联系我们</p>

        <div class="contact-content">
          <div class="telinner">
            <div class="polite">
              您好，
              <br />欢迎致电厚科，我们随时为您提供服务
            </div>
            <ul class="tel-list">
              <li>
                <span>客服电话：</span>
                <a href="tel:0755-86250886">0755-86250886</a>
              </li>
              <li>
                <span>业务咨询：</span>
                <a href="tel:0755-86577078">0755-86577078</a>
              </li>
              <li>
                <span>值班电话：</span>
                <a href="tel:18938914511">18938914511</a>
              </li>
              <li>
                <span>应急电话：</span>
                <a href="tel:15019476486">15019476486</a>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li class="contact-item">
        <img class="weChat-logo" src="~@/assets/imgs/weChat_logo.png" alt />
        <p class="contact-text">公众号</p>
        <div class="contact-content">
          <div class="wxinner">
            <img class="f-qr" src="~@/assets/imgs/weChat_qr.png" alt />
            <div class="wxinner-text">
              <p>厚科技术</p>
              <p>微信公众号</p>
            </div>
          </div>
        </div>
      </li>
      <li class="contact-item" @click="backTop()">
        <svg-icon icon-class="icon_contact_rocket" class-name="contact_rocket_svg"></svg-icon>
        <p class="contact-text">返回顶部</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Contact",
  methods: {
    backTop() {
      let distanceY = window.pageYOffset;
      let i = 0;
      this.interval = setInterval(() => {
        let next = Math.floor(
          this.easeInOutQuad(10 * i, distanceY, -distanceY, 500)
        );
        if (next <= 0) {
          window.scrollTo(0, 0);
          clearInterval(this.interval);
        } else {
          window.scrollTo(0, next);
        }
        i++;
      }, 16);
    },

    /*
      缓动公式（Tween算法）
       t: 动画已经执行的时间（实际上时执行多少次/帧数）
       b: 起始位置
       c: 终止位置
       d: 从起始位置到终止位置的经过时间（实际上时执行多少次/帧数）
    */
    easeInOutQuad(t, b, c, d) {
      // 判断当前时间是否总在总时间的一半以内，是的话执行缓入函数，否则的话执行缓出函数
      if ((t /= d / 2) < 1) {
        return (c / 2) * t * t + b;
      } else {
        // 将总长度设置为一半，并且时间从当前开始递减，对图像进行垂直向上平移
        return (-c / 2) * (--t * (t - 2) - 1) + b;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contact {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 10002;
  .contact-list {
    position: relative;
    .contact-item {
      width: 64px;
      height: 64px;
      background: #00173a;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
      &:nth-child(1) {
        border-radius: 4px 0px 0px 0px;
      }
      &:nth-child(3) {
        border-radius: 0px 0px 0px 4px;
      }
      &:hover .contact-content {
        display: block;
      }
      .contact_tel_svg {
        font-size: 26px;
      }
      .contact_rocket_svg {
        font-size: 32px;
      }
      .weChat-logo {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
      .contact-text {
        text-align: center;
        color: #fff;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        margin-top: 2px;
      }

      .contact-content {
        height: 192px;
        background: #fff;
        margin-right: -5px;
        border-radius: 4px 0px 0px 4px;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
        position: absolute;
        top: 0;
        right: 64px;
        z-index: -1;
        text-align: initial;
        display: none;
        .wxinner {
          padding: 32px 42px;
          .f-qr {
            width: 82px;
            height: 82px;
          }
          .wxinner-text {
            font-size: 12px;
            font-weight: 300;
            color: #000;
            margin-top: 8px;
            text-align: center;
          }
        }

        .telinner {
          padding: 16px 24px;
          width: 288px;
          font-size: 14px;
          font-weight: 300;
          color: rgba(0, 0, 0, 0.85);
          line-height: 20px;
          .polite {
            line-height: 24px;
          }

          .tel-list {
            margin-top: 16px;
            > li {
              line-height: 24px;
              a {
                color: #0088ff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
